import React, { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer } from '@kineticdata/react';
import { Header } from './layout/Header';
import { SidebarNav } from './layout/SidebarNav';
import { SystemSetup } from './system/SystemSetup';
import { SystemLicense } from './system/SystemLicense';
import { SystemComponents } from './system/SystemComponents';
import { commitStore } from '../root';
import { ConfirmationModal } from './common/ConfirmationModal';
import { Spaces } from './spaces';

export const RootLayout = props => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => commitStore(), []);

  return (
    <div className="app-wrapper">
      <Header />
      <div className="app-layout">
        <aside className="app-sidebar app-sidebar--inverse">
          <SidebarNav />
        </aside>
        <div className="app-body">
          <main className="app-content">
            <ToastContainer />
            <Routes>
              <Route path="/" element={<Navigate to="/spaces" replace />} />
              <Route path="/spaces/*" element={<Spaces />} />
              <Route path="/system/setup/*" element={<SystemSetup />} />
              <Route path="/system/licensing" element={<SystemLicense />} />
              <Route path="/system/components" element={<SystemComponents />} />
            </Routes>
            <ConfirmationModal />
          </main>
        </div>
      </div>
    </div>
  );
};
